<template>
  <div>
    <breadcrumbPage @search="search($event)"
                    :searchValue1="keywordsSear"
                    :searchTag="true"></breadcrumbPage>
    <div class="content EC_width">
      <div class="leftContent">
        <div class="leftTitle display_between">
          <div class="leftTitleText">热门搜索词</div>
        </div>
        <ul class="ulList_block">
          <li v-for="(item, index) in hotkeyeords"
              :key="index"
              @click="search({ value: item.labelName, key: 1 })">
            <a href="javascript:;">{{ item.labelName }}</a>
          </li>
        </ul>
      </div>
      <div class="rightList">
        <div class="titleTageWrap display_between">
          <div>
            <span class="tagTitle"
                  :class="{ tagTitleActive: tagIndex == 'ShInforList' }"
                  @click="tagContent('ShInforList', 0)">资讯
              ({{searchinfoCount}})
            </span>
            <span class="tagTitle"
                  :class="{ tagTitleActive: tagIndex == 'ShCourseList' }"
                  @click="tagContent('ShCourseList', 1)">课程
              ({{searchvideoCount}})
            </span>
            <span class="tagTitle"
                  :class="{ tagTitleActive: tagIndex == 'ShLiteList' }"
                  @click="tagContent('ShLiteList', 2)">文献
              ({{searchwenxinCount}})
            </span>
          </div>
          <div class="opra">
            为您搜索到：
            <span class="searchreultcount">{{ keywordsSear }} {{ searchCount }}</span>
            条结果
            <el-select v-model="allDatemod"
                       placeholder="所有可用日期"
                       @change="selectChange()"
                       v-if="tagIndexmuber == 2">
              <el-option v-for="item in allDate"
                         :key="item"
                         :label="item"
                         :value="item"></el-option>
            </el-select>
          </div>
        </div>
        <component :is="tagIndex"
                   :datalist="listData"
                   :ishow="searchresultishow"></component>
        <!-- 分页器 -->
        <div class="pagination_Wrap"
             v-if="pageCount > 0">
          <pagination :total="pageCount"
                      :limit="pageSize"
                      :page="pageIndex"
                      @page-change="pageChange"></pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbPage from '../home/breadcrumbPage';
import ShCourseList from './ShCourseList';
import ShInforList from './ShInforList';
import ShLiteList from './ShLiteList';
import lodash from 'lodash';
export default {
  name: 'searchPage',
  data () {
    return {
      tagIndex: 'ShInforList',
      tagIndexmuber: 0,
      /**tianlianpei */
      //总条数
      searchCount: 0,
      searchinfoCount: 0,
      searchvideoCount: 0,
      searchwenxinCount: 0,
      ncurrentPage: 1, //资讯
      ccurrentPage: 1, //课程
      acurrentPage: 1, //文献
      pageSize: 8, //统一显示20条
      course_Type: 0,
      keywordsresult: '', //搜索词显示
      //资讯列表
      newsList: [],
      //课程列表
      courseList: [],
      //文章列表
      articlelist: [],
      newCount: 0,
      courseCount: 0,
      articleCount: 0,
      // 热门搜索词
      hotkeyeords: [],
      // 搜索关键词下拉
      searValueKey: '1',
      searchKeywords: [
        { label: '全部', value: '1' },
        { label: '标题', value: '2' },
        { label: '标签', value: '3' },
        { label: '作者', value: '4' },
        { label: '单位', value: '5' },
        { label: '摘要', value: '6' },
      ],
      // 输入框搜索
      keywordsSear: '',
      // 课程搜索tab
      courClasnav: 0,
      courseNavi: [{ title: '资讯' }, { title: '课程' }, { title: '文献' }],
      // 所有可用日期
      allDatemod: '',
      allDate: [],
      // 课程分类
      tabcencou: 0,
      pageCount: 0,
      pageIndex: 1,
      listData: [],
      searchresultishow: false,
    };
  },
  components: {
    ShCourseList,
    ShInforList,
    ShLiteList,
    breadcrumbPage,
  },
  created () {
    if (this.$route.params.labelname != '') {
      this.keywordsSear = this.$route.params.labelname;
    }
    if (this.$route.query.tagIndexmuber) {
      switch (this.$route.query.tagIndexmuber) {
        case 'ShInforList':
          this.tagIndexmuber = 0;
          break;
        case 'ShCourseList':
          this.tagIndexmuber = 1;
          break;
        case 'ShLiteList':
          this.tagIndexmuber = 2;
          break;
      }
      this.tagIndex = this.$route.query.tagIndexmuber;
    }
    this.getData();
    this.getCount();
    this.GetPopularContent();
  },
  methods: {
    GetPopularContent () {
      let _this = this;
      _this.httphelper.get('/api/NewApi/GetPopularContent').then(res => {
        if (res.code == 200) {
          _this.hotkeyeords = res.data || null;
        }
      });
    },
    /**点击分页事件 */
    pageChange (page) {
      if (document.body.scrollTop) {
        document.body.scrollTop = 0;
      } else {
        document.documentElement.scrollTop = 0;
      }
      if (page == this.pageIndex) {
        return;
      }
      this.listData = [];
      this.pageIndex = page;
      this.getData();
    },
    tagContent (index, indexmuber) {
      this.pageCount = 0;
      this.listData = [];
      this.tagIndexmuber = indexmuber;
      this.pageIndex = 1;
      if (indexmuber == 0) {
        this.pageSize = 8;
      } else if (indexmuber == 1) {
        this.pageSize = 9;
      } else if (indexmuber == 2) {
        this.pageSize = 8;
      }
      this.getData();
      this.tagIndex = index;
    },
    search (datajson) {
      this.tagIndex = 'ShInforList';
      this.tagIndexmuber = 0;
      this.pageCount = 0;
      this.searValueKey = datajson.key;
      this.listData = [];
      this.keywordsSear = datajson.value;
      this.searchresultishow = false;
      this.getCount();
      this.getData();
    },
    selectChange () {
      this.listData = [];
      this.getData();
    },
    getData () {
      let _this = this;
      _this.keywordsresult = _this.keywordsSear;

      _this.httphelper
        .post('/api/NewApi/GetSearchResultList', {
          keyword: _this.keywordsSear,
          lablename: '',
          type: 0,
          category: parseInt(_this.searValueKey),
          course_Type: 1,
          year: _this.allDatemod != '' ? parseInt(_this.allDatemod) : 0,
          orderBy: 0,
          pageIndex: _this.pageIndex,
          pageSize: _this.pageSize,
        })
        .then(res => {
          if (res.data.code == 200) {
            _this.newCount = 0;
            _this.courseCount = 0;
            _this.articleCount = 0;
            _this.newsList = [];
            _this.articlelist = [];
            _this.courseList = [];
            _this.allDate = [];
            var nlist = res.data.data.newlist;
            var clist = res.data.data.courselist;
            var alist = res.data.data.articlelist;
            if (_this.tagIndexmuber == 0 && nlist != null && nlist.data.gpSiteNewInfoViewsViews != null && nlist.data.gpSiteNewInfoViewsViews.length > 0) {
              _this.newsList = nlist.data.gpSiteNewInfoViewsViews;
              _this.newCount = nlist.data.pageCount;
              _this.listData = _this.newsList;
              _this.pageCount = _this.newCount;
            }
            if (_this.tagIndexmuber == 1 && clist != null && clist.data.gpCourseVideoInfoViews != null && clist.data.gpCourseVideoInfoViews.length > 0) {
              _this.courseList = clist.data.gpCourseVideoInfoViews;

              _this.listData = lodash.chunk(_this.courseList, 3);
              _this.courseCount = clist.data.pageCount;
              _this.pageCount = _this.courseCount;
            }
            if (_this.tagIndexmuber == 2 && alist != null && alist.data.gpSiteArticleInfoViews != null && alist.data.gpSiteArticleInfoViews.length > 0) {
              _this.articlelist = alist.data.gpSiteArticleInfoViews;
              _this.allDate = alist.data.yearListViews;
              _this.articleCount = alist.data.pageCount;
              _this.listData = _this.articlelist;
              _this.pageCount = _this.articleCount;
            }
            if (_this.pageCount == 0) {
              _this.searchresultishow = true;
            }
          }
        });
    },
    getCount () {
      let _this = this;
      let currentPage;
      if (_this.tagIndexmuber == 0) currentPage = _this.ncurrentPage;
      else if (_this.tagIndexmuber == 1) currentPage = _this.ccurrentPage;
      else if (_this.tagIndexmuber == 2) currentPage = _this.acurrentPage;

      _this.keywordsresult = _this.keywordsSear;
      _this.searchCount = 0;
      _this.searchinfoCount = 0;
      _this.searchvideoCount = 0;
      _this.searchwenxinCount = 0;
      _this.httphelper
        .post('/api/NewApi/GetSearchResultList', {
          keyword: _this.keywordsSear,
          lablename: '',
          type: 0,
          category: parseInt(_this.searValueKey),
          course_Type: 1,
          year: _this.allDatemod != '' ? parseInt(_this.allDatemod) : 0,
          orderBy: 0,
          pageIndex: currentPage,
          pageSize: _this.pageSize,
        })
        .then(res => {
          if (res.data.code == 200) {
            var nlist = res.data.data.newlist;
            var clist = res.data.data.courselist;
            var alist = res.data.data.articlelist;
            if (nlist != null && nlist.data.gpSiteNewInfoViewsViews) {
              _this.searchinfoCount = nlist.data.pageCount;
              _this.searchCount = _this.searchCount + nlist.data.pageCount;
            }
            if (clist != null && clist.data.gpCourseVideoInfoViews) {
              _this.searchvideoCount = clist.data.pageCount;
              _this.searchCount = _this.searchCount + clist.data.pageCount;
            }
            if (alist != null && alist.data.gpSiteArticleInfoViews != null) {
              _this.searchwenxinCount = alist.data.pageCount;
              _this.searchCount = _this.searchCount + alist.data.pageCount;
            }
          }
        });
    },
  },
};
</script>

<style scoped>
.content {
    padding-top: 20px;
    flex: 1;
    display: flex;
}
.leftContent {
    width: 310px;
}
.leftTitle {
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid #ddd;
}
.leftTitleText {
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #333;
}
.linkRight li {
    margin-bottom: 20px;
}
/* 右边样式设置 */
.rightList {
    flex: 1;
    margin-left: 50px;
}
.titleTageWrap {
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 20px;
}
.opra {
    color: #666;
}
.tagTitle {
    display: inline-block;
    height: 100%;
    font-size: 18px;
    cursor: pointer;
    font-weight: bold;
    position: relative;
    margin-right: 20px;
}

.tagTitle ~ .tagTitle::before {
    content: '/';
    margin: 0 14px;
    color: #ddd;
    position: absolute;
    left: -28px;
}

.tagTitleActive {
    border-bottom: 1px solid #0b8686;
    color: #0b8686;
}
</style>
